import { CheckCircle2, PhoneCall } from "lucide-react";
import { PROCESS_STEPS, IMAGES, PHONE_TEL } from "../../data/content";

export const ProcessSection = () => (
  <section className="py-24 sm:py-32 border-b border-zinc-800/60 relative overflow-hidden" data-testid="process-section">
    <div className="absolute inset-0 opacity-10">
      <img src={IMAGES.process} alt="Mobile mechanic working on a customer's vehicle on location" className="w-full h-full object-cover" />
    </div>
    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <div className="mb-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">How It Works</span>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mt-4">
          Fixed in Four Simple Steps
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
        {PROCESS_STEPS.map((step, i) => (
          <div key={step.step} className="relative" data-testid={`process-step-${i + 1}`}>
            <div className="font-heading text-5xl font-bold text-blue-600/25 mb-4">{step.step}</div>
            <h3 className="font-heading text-lg font-semibold text-white mb-2">{step.title}</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">{step.desc}</p>

            {step.badge && (
              <div className="mt-4 bg-blue-600/10 border border-blue-500/30 rounded-sm p-3" data-testid="same-day-badge">
                <div className="flex items-center gap-1.5 text-blue-400 text-xs font-semibold">
                  <CheckCircle2 className="h-3.5 w-3.5 shrink-0" /> {step.badge.title}
                </div>
                <div className="text-zinc-500 text-xs mt-1">{step.badge.sub}</div>
              </div>
            )}

            {step.badges && (
              <div className="mt-4 flex flex-wrap gap-2" data-testid="trust-badges">
                {step.badges.map((b) => (
                  <span key={b} className="inline-flex items-center gap-1 border border-zinc-700 text-zinc-300 rounded-sm px-2.5 py-1 text-[11px] font-medium">
                    <CheckCircle2 className="h-3 w-3 text-blue-500 shrink-0" /> {b}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-16 border-t border-zinc-800/60 pt-8 flex items-start gap-3" data-testid="process-questions-line">
        <PhoneCall className="h-4 w-4 text-blue-500 shrink-0 mt-0.5" />
        <p className="text-zinc-400 text-sm leading-relaxed">
          Questions before booking?{" "}
          <a href={PHONE_TEL} className="text-blue-400 font-semibold hover:text-blue-300" data-testid="process-call-link">Call or text us</a>{" "}
          please! We're happy to answer questions, explain the repair process, or help you choose the right service before scheduling.
        </p>
      </div>
    </div>
  </section>
);
